import React, {useEffect, useState} from "react";
import {deleteResource, getByIdResource} from "../../service/http-service";
import './ProfileSegmentStyle.css'
import DeleteModal from "../../ui/DeleteModal";
import Edit from '../../../assets/img/profile-images/Uredi-icon.png';
import Delete from '../../../assets/img/profile-images/Izbrisi-icon.png';
import Plus from '../../../assets/img/profile-images/Otvori-icon.png';
import Minus from '../../../assets/img/profile-images/Zatvori-icon.png';
import {GenericEditModalForm} from "./GenericEditModalForm";


export const ProfileLanguageSegment = ({candidate, isPreview}) => {

    const [resultListEmpty, setResultListEmpty] = useState(true);
    const [showOneElement, setShowOneElement] = useState(true);
    const [firstElementFromList, setFirstElementFromList] = useState({})
    const [candidateExistingList, setCandidateExistingList] = useState([]);
    const [updateForeignLanguages, setUpdateForeignLanguage] = useState(false)

    const [entity, setEntity] = useState({candidate: candidate});
    const [addEntity, setAddEntity] = useState(false);
    const [updateEntity, setUpdateEntity] = useState(false)


    const getCandidateExistingList = () => {
        getByIdResource('candidates_foreign_language/get_by_candidate', candidate.id).then((data) => {
            setCandidateExistingList(data.data);
            setFirstElementFromList(data.data[0])
            if(data.data && data.data.length > 1){
                if(isPreview){
                    setShowOneElement(false);
                }
                setResultListEmpty(false)
            } else if(data.data && data.data.length === 1){
                setResultListEmpty(false)
            }else {
                setResultListEmpty(true);
            }
        })
    }
    const confirmDelete = (data, url, refreshEntity, setRefreshEntity) => {
        deleteResource(url, data).then(() =>{
            setRefreshEntity(!refreshEntity);
        }).catch((error) => {
            console.log('error')
        })
    }


    useEffect(()=> {
        getCandidateExistingList();
    },[])

    useEffect(() => {
        getByIdResource('candidates_foreign_language/get_by_candidate', candidate.id).then(data => {
            setCandidateExistingList(data.data);
        })
    }, [updateEntity, updateForeignLanguages])



    return(
        <div className='profile_segment_main_container'>
            {firstElementFromList && (candidateExistingList && candidateExistingList.length > 0) && showOneElement ?
                <div className='profile_segment_separate_info d-flex justify-content-between'>
                   <div>
                       {firstElementFromList.foreignLanguage &&  <h5>{firstElementFromList.otherLanguage ? firstElementFromList.otherLanguage :
                           firstElementFromList.foreignLanguage && firstElementFromList.foreignLanguage.name}</h5>}

                       {firstElementFromList.languageReadingLevel && <p>Читање: <span>
                        {firstElementFromList.languageReadingLevel && firstElementFromList.languageReadingLevel.name}</span></p>}

                       {firstElementFromList.languageSpeakingLevel && <p>Зборување: <span>
                        {firstElementFromList.languageSpeakingLevel && firstElementFromList.languageSpeakingLevel.name}</span></p>}

                       {firstElementFromList.languageWritingLevel && <p>Пишување: <span>
                        {firstElementFromList.languageWritingLevel && firstElementFromList.languageWritingLevel.name}</span></p>}
                   </div>

                   <div className="icons-div justify-self-end">
                       {!isPreview &&  <div className="edit_delete_icons">
                           <img src={Edit} alt="edit" onClick={() => {
                               setShowOneElement(false)
                               setEntity(firstElementFromList)
                               setAddEntity(true)}
                           }/>
                           <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                               confirmDelete(firstElementFromList, 'candidates_foreign_language', updateForeignLanguages, setUpdateForeignLanguage)}/>
                       </div>}
                   </div>

                </div> :
                candidateExistingList.map(entity =><>
                    <div className='profile_segment_separate_info d-flex justify-content-between' key={entity.id}>
                        <div>
                            {entity.foreignLanguage &&  <h5>{entity.otherLanguage ? entity.otherLanguage :
                                entity.foreignLanguage && entity.foreignLanguage.name}</h5>}

                            {entity.languageReadingLevel && <p>Читање: <span>
                        {entity.languageReadingLevel && entity.languageReadingLevel.name}</span></p>}

                            {entity.languageSpeakingLevel && <p>Зборување: <span>
                        {entity.languageSpeakingLevel && entity.languageSpeakingLevel.name}</span></p>}

                            {entity.languageWritingLevel && <p>Пишување: <span>
                        {entity.languageWritingLevel && entity.languageWritingLevel.name}</span></p>}
                        </div>
                        <div className="icons-div justify-self-end">
                           {!isPreview && <div className="edit_delete_icons">
                               <img src={Edit} alt="edit" onClick={() => {
                                   setShowOneElement(false)
                                   setEntity(entity)
                                   setAddEntity(true)}
                               }/>
                               <DeleteModal btnText={<img src={Delete} alt="delete"/>}  btnClass="apply-btn" confirmDelete={() =>
                                   confirmDelete(entity, 'candidates_foreign_language', updateForeignLanguages, setUpdateForeignLanguage)}/>
                            </div>}
                        </div>
                      </div>
                      <hr/>
                    </>
                )}

            {!isPreview && !addEntity && (!showOneElement || resultListEmpty ) && (<div className="profile_add_button mt-3"
                                                                                        onClick={() =>
                                                                                        {setEntity({...entity, candidate: candidate})
                                                                                            setAddEntity(true)}}
            >Додади јазик</div>)}
            {addEntity === true && (<div className="open-form">  <GenericEditModalForm
                type="LANGUAGE"
                title= {!entity.id ? "Додади јазик" : "Уреди јазик"}
                entity={entity} setEntity={setEntity}
                addEntity={addEntity} setAddEntity={setAddEntity}
                updateEntity={updateEntity} setUpdateEntity={setUpdateEntity}/></div>)}

            {(!isPreview && !resultListEmpty) &&
                <>
                    <div className='profile_plus_container'><hr/>
                        {showOneElement ?  <img src={Plus} alt='plus' onClick={()=> setShowOneElement(false)}/> :
                            <img src={Minus} alt='plus' onClick={()=> {
                                setShowOneElement(true)
                            setAddEntity(false)}
                            }/>}
                    </div>
                </>
            }
        </div>
    )
}